interface Row {
    col: number
    row: number
    size_x: number
    size_y: number
    id: number
}
interface Rows {
    [id: string]: Row[]
}
const getMinAndMaxRow = (widgets: Row[], min?: number, max?: number): [number, number] => {
    const minRef = min ? min : widgets[0].col
    const maxRef = max ? max : widgets[0].col
    return widgets.reduce(([min, max], { col }) => [Math.min(min, col), Math.max(max, col)], [minRef, maxRef])
}

export function mergeGridRows(rows: Rows): Rows {
    return Object.entries(rows).reduce((state, [position, row]) => {
        if (position === '1') {
            state[position] = row
        }

        const [minCol, maxCol] = getMinAndMaxRow(state['1'])

        const [widgetsRow, movedWidgetsRow] = row.reduce(
            ([currentWidgets, movedWidgets], widget) => {                
                if (widget.col < minCol || widget.col > maxCol) {
                    movedWidgets.push(widget)
                } else {
                    currentWidgets.push(widget)
                }

                return [currentWidgets, movedWidgets]
            },
            [[], []] as [Row[], Row[]]
        )

        movedWidgetsRow.forEach(widget => {
            if (widget.col < minCol) state['1'] = [widget, ...state['1']]
            else state['1'] = [...state['1'], widget]
        })

        if (widgetsRow.length > 0) state[position] = widgetsRow

        return state
    }, {} as Rows)
}